import type { NitroFetchRequest, $Fetch } from 'nitropack'
import type { FetchOptions } from 'ofetch'
import type { GetBlogDetailResponse } from '~/types/apis/v2/getBlogDetail'
import type { GetBlogListResponse } from '~/types/apis/v2/getBlogList'

export const BlogRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getBlogDetail(
    blogSlug: string,
    language: string,
    options: FetchOptions = {}
  ): Promise<GetBlogDetailResponse> {
    return fetch<GetBlogDetailResponse>(`/v2/storefront/blog/${blogSlug}`, {
      ...options,
      method: 'GET',
      headers: {
        'Accept-Language': language
      }
    })
  },
  async getBlogList(
    query: {
      all?: boolean
      order_by?: string
      sort_by?: string
      page?: number
      per_page?: number
    },
    language: string,
    options: FetchOptions = {}
  ): Promise<GetBlogListResponse> {
    return fetch<GetBlogListResponse>(`/v2/storefront/blog`, {
      ...options,
      method: 'GET',
      query,
      headers: {
        'Accept-Language': language
      }
    })
  }
})
